"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.update = exports.clienteNovoCadastro = exports.createNovoDependente = exports.create = exports.findOne = exports.findAllClienteLogadoMaisSeusDependentes = exports.findAll = void 0;
const core_1 = require("./core");
function findAll(page = 1, search) {
    return core_1.get('Cliente', 'lista', Object.assign({ pg: page }, search))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAll = findAll;
function findAllClienteLogadoMaisSeusDependentes(page = 1, search) {
    return core_1.get('Cliente', 'listaClienteLogadoMaisSeusDependentes', Object.assign({ pg: page }, search))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAllClienteLogadoMaisSeusDependentes = findAllClienteLogadoMaisSeusDependentes;
function findOne(id) {
    return core_1.get('Cliente', 'detalhe', { id });
}
exports.findOne = findOne;
function create(data) {
    return core_1.post('Cliente', 'cadastro', Object.assign({}, data));
}
exports.create = create;
function createNovoDependente(data) {
    return core_1.post('Cliente', 'cadastroNovoDependente', Object.assign({}, data));
}
exports.createNovoDependente = createNovoDependente;
function clienteNovoCadastro(data) {
    return core_1.post('Cliente', 'cadastroNovoCliente', Object.assign({}, data));
}
exports.clienteNovoCadastro = clienteNovoCadastro;
function update(id, data) {
    return core_1.put('Cliente', 'update', Object.assign({ id }, data));
}
exports.update = update;
function remove(id) {
    return core_1.del('Cliente', 'exclui', { id });
}
exports.remove = remove;
